import { useEffect, useState } from 'react';

// Detached images use the browser HTTP cache; no unbounded decoded-image cache.
export function useLearningImage(src: string, priority: 'high' | 'auto' = 'auto') {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState<{ image: HTMLImageElement | null; status: 'loading' | 'ready' | 'error' }>({ image: null, status: 'loading' });
  useEffect(() => {
    let active = true;
    const image = new Image();
    image.decoding = 'async';
    image.fetchPriority = priority;
    setState({ image: null, status: 'loading' });
    const fail = () => { if (active) { active = false; window.clearTimeout(timeout); image.removeAttribute('src'); setState({ image: null, status: 'error' }); } };
    const timeout = window.setTimeout(fail, 45000);
    image.onerror = fail;
    image.onload = async () => {
      try {
        await image.decode();
        if (active) { window.clearTimeout(timeout); setState({ image, status: 'ready' }); }
      } catch { fail(); }
    };
    image.src = src;
    return () => { active = false; window.clearTimeout(timeout); image.onload = null; image.onerror = null; image.removeAttribute('src'); };
  }, [src, attempt, priority]);
  return { ...state, retry: () => setAttempt(value => value + 1) };
}

export function usePrefetchNextImage(src: string | undefined, ready: boolean) {
  useEffect(() => {
    const connection = (navigator as Navigator & { connection?: { saveData?: boolean; effectiveType?: string } }).connection;
    if (!src || !ready || connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType ?? '')) return;
    let image: HTMLImageElement | undefined;
    const timer = window.setTimeout(() => { image = new Image(); image.fetchPriority = 'low'; image.src = src; }, 1200);
    return () => { window.clearTimeout(timer); image?.removeAttribute('src'); };
  }, [src, ready]);
}
